































import { Component, Prop, Vue } from 'vue-property-decorator';
import { InputVariableViewModel } from '../../../models/designer';
import Icon from '@/shared/icons/Icon.vue';
import AttributeIconUtil from '../../../../../shared/util/attributeIconUtil';
@Component({
	components: {
		Icon
	}
})
export default class VariableBadge extends Vue {
	@Prop() public id: string;
	@Prop() public variable: InputVariableViewModel;
	@Prop() public fallback: string;

	public fallbackValue: string = '';
	public isOpen: boolean = false;
	public icon: string = '';
	public invalid: boolean = false;

	public created() {
		this.fallbackValue = this.fallback;
		this.invalid = !this.isValid();
		this.icon = this.getIcon();
	}

	public update() {
		this.invalid = !this.isValid();
		this.icon = this.getIcon();
	}

	public getIcon(): string {
		if (this.invalid) {
			return 'ErrorIcon';
		} else {
			return AttributeIconUtil.getIcon(this.variable.dataType, this.variable.key, false) || '';
		}
	}

	public isValid(): boolean {
		return !this.variable.error;
	}

	public closeFallback() {
		this.isOpen = false;
		this.$emit('closedFallback');
	}

	public getError() {
		if (this.variable.error) {
			return this.variable.error;
		}
	}
}
